import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { BookingProvider } from './contexts/BookingContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Toaster } from './components/ui/sonner';

// Public Pages
import Home from './pages/public/Home';
import PropertiesList from './pages/public/Properties';
import PropertyDetail from './pages/public/PropertyDetail';
import SearchResults from './pages/public/SearchResults';
import Checkout from './pages/public/Checkout';
import BookingConfirmation from './pages/public/BookingConfirmation';
import BookingLookup from './pages/public/BookingLookup';

// Admin Pages
import AdminLogin from './pages/admin/Login';
import AdminDashboard from './pages/admin/Dashboard';
import AdminProperties from './pages/admin/Properties';
import AdminRooms from './pages/admin/Rooms';
import AdminBookings from './pages/admin/Bookings';
import AdminUsers from './pages/admin/Users';
import AdminDiary from './pages/admin/Diary';
import AdminCalendar from './pages/admin/Calendar';
import AdminGuests from './pages/admin/Guests';
import AdminLedger from './pages/admin/Ledger';
import AdminHousekeeping from './pages/admin/Housekeeping';
import GuestRegister from './pages/public/GuestRegister';
import PropertyBookingPage from './pages/public/PropertyBookingPage';

import './App.css';

function App() {
  return (
    <AuthProvider>
      <BookingProvider>
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/properties" element={<PropertiesList />} />
            <Route path="/properties/:id" element={<PropertyDetail />} />
            <Route path="/search" element={<SearchResults />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/booking/confirmation/:reference" element={<BookingConfirmation />} />
            <Route path="/booking/lookup" element={<BookingLookup />} />
            <Route path="/register/:slug" element={<GuestRegister />} />

            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/properties"
              element={
                <ProtectedRoute requiredRoles={['superadmin']}>
                  <AdminProperties />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/rooms"
              element={
                <ProtectedRoute>
                  <AdminRooms />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/bookings"
              element={
                <ProtectedRoute>
                  <AdminBookings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/users"
              element={
                <ProtectedRoute requiredRoles={['superadmin']}>
                  <AdminUsers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/diary"
              element={
                <ProtectedRoute>
                  <AdminDiary />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/calendar"
              element={
                <ProtectedRoute>
                  <AdminCalendar />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/guests"
              element={
                <ProtectedRoute>
                  <AdminGuests />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/ledger"
              element={
                <ProtectedRoute>
                  <AdminLedger />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/housekeeping"
              element={
                <ProtectedRoute>
                  <AdminHousekeeping />
                </ProtectedRoute>
              }
            />

            {/* Property-specific public page (must be last) */}
            <Route path="/:slug" element={<PropertyBookingPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </BookingProvider>
    </AuthProvider>
  );
}

export default App;
